var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('banner'),_vm._v(" "),_c('news'),_vm._v(" "),_c('functions'),_vm._v(" "),_c('recommend'),_vm._v(" "),_c('zhuanye'),_vm._v(" "),_c('info'),_vm._v(" "),_c('region',{attrs:{"data":_vm.data.ip_info},on:{"reload":function($event){return _vm.reload111()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce6ed0bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
// module id = null
// module chunks = 